<template>
  <div>
    <div  v-if="loadingSearch" class="content-network-data d-flex justify-content-center align-items-center">
      <b-spinner label="Loading" variant="primary" />
    </div>
    <template v-else>
      <template v-if="networkConfigData.length">
        <div class="content-network-data">
          <b-alert
            :show="showAlert"
            variant="danger"
            class="p-1 mb-1"
          >
            <feather-icon
              icon="AlertCircleIcon"
              size="18"
              style="margin-right: 5px;"
            />
            No hay cambios en la configuración de redes
          </b-alert>
          <NetworkConfig
            v-if="selectedNetwork"
            :selectedNetwork="selectedNetwork"
            @network-config-close="selectedNetwork = null"
          />
          <Details
            v-else
            :bandWidthData="bandWidthData"
            :defaultGateway="defaultGateway"
            :networkConfigData="networkConfigData"
            :networkGatewayDefault="networkGatewayDefault"
            @network-gateway-default-change="gatewayDefaultChange"
            @select-network="selectNetwork"
            @update:networkGatewayDefault="setNetworkGatewayDefault"
          />
        </div>
        <div v-if="!selectedNetwork" class="text-right">
          <button
            type="button"
            class="btn btn-primary"
            :disabled="loading"
            @click="saveNetworkData()"
          >
            {{ buttonText }}
          </button>
        </div>
      </template>
      <div  v-else class="content-network-data">
        <b-alert
          show
          variant="warning"
          class="p-1 mb-1"
        >
          <feather-icon
            icon="AlertCircleIcon"
            size="18"
            style="margin-right: 5px;"
          />
          Sin información de red
        </b-alert>
      </div>
    </template>
  </div>
</template>

<script>
import { computed,onMounted,ref } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import popperHelper from "@/libs/popper-helper";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Details from "./Details.vue";
import NetworkConfig from "./NetworkConfig.vue";
import axios from "@axios";

export default {
  props: {
    hanwhaDvr: {
      type: Object,
      require: true
    },
    isModalNetworkConfigActive: {
      type: Boolean,
      require: true
    }
  },
  components:{
    Details,
    NetworkConfig
  },
  setup (props, { emit }) {
    //HOOKS
    onMounted(async () => await fetchNetworkData());

    //COMPOSABLES
    const toast = useToast();

    //DATA
    const bandWidthData = ref({
      min: 0,
      max: 0
    });

    const defaultGateway = ref(null);

    const dnsTypes = [
      {
        label: 'Apagado',
        value: false
      },
      {
        label: 'Encendido',
        value: true
      }
    ];

    const fields = ref([
      { key: 'Channel', label: 'Canal', thClass: 'text-center py-1', tdClass: 'text-center'},
      { key: 'NormalMode', label: 'Grabación continua',thClass: 'text-center py-1', tdClass: 'text-center'},
      { key: 'EventMode', label: 'Grabación de eventos',thClass: 'text-center py-1', tdClass: 'text-center'},
      { key: 'FullFrameBandWidth', label: 'Marco completo',thClass: 'text-center py-1', tdClass: 'text-center' },
      { key: 'KeyFrameBandWidth', label: 'Cuadro I',thClass: 'text-center py-1', tdClass: 'text-center' },
      { key: 'BitrateLimit', label: 'Límite',thClass: 'text-center py-1', tdClass: 'text-center' },
      { key: 'PreEventDuration', label: 'Pre evento',thClass: 'text-center py-1', tdClass: 'text-center' },
      { key: 'PostEventDuration', label: 'Post evento',thClass: 'text-center py-1', tdClass: 'text-center' },
      { key: 'AudioEnable', label: 'Audio',thClass: 'text-center py-1', tdClass: 'text-center' }
    ]);

    const ipTypes = [
      {
        label: 'Apagado',
        value: false
      },
      {
        label: 'Encendido',
        value: true
      }
    ];

    const loading = ref(false);

    const loadingSearch = ref(false);

    const networkConfigData = ref([]);

    const networkGatewayDefault = ref(null);

    const originalNetworksData = ref([]);

    const selectedNetwork = ref(null);

    const showAlert = ref(false);

    //COMPUTED
    const bandWidthLimit = computed(() => bandWidthData.value.max);

    const buttonText = computed(() => (loading.value) ? 'Guardando...' : 'Guardar');

    //METHODS
    const buildBandWitdhData = (dataResponseBandWidth) => {
      dataResponseBandWidth.data.NetworkBandwidths.forEach(nb => {
        const network = networkConfigData.value.find(ncd => (nb.InterfaceName === ncd.InterfaceName));
        const originalNetwork = originalNetworksData.value.find(ncd => (ncd.InterfaceName === nb.InterfaceName));

        if (network) {
          network.Bandwidth = nb.Bandwidth;
        }

        if (originalNetwork) {
          originalNetwork.Bandwidth = nb.Bandwidth;
        }
      });

      const gateway = networkConfigData.value.find(ncd => ncd.IsDefaultGateway);

      if (gateway) {
        defaultGateway.value = gateway;
        networkGatewayDefault.value = gateway.InterfaceName;
      }
    }

    const buildDnsData = (dataResponseDns) => {
      dataResponseDns.data.DNS.forEach(dns => {
        const network = networkConfigData.value.find(ncd => (ncd.InterfaceName === dns.InterfaceName));
        const originalNetwork = originalNetworksData.value.find(ncd => (ncd.InterfaceName === dns.InterfaceName));
        const [dnsIpv4] = dns.DNSByIPType;

        if (network) {
          network.PrimaryDNS = dnsIpv4.PrimaryDNS;
          network.DnsType    = dnsIpv4.Type;
        }

        if (originalNetwork) {
          originalNetwork.PrimaryDNS = dnsIpv4.PrimaryDNS;
          originalNetwork.DnsType    = dnsIpv4.Type;
        }
      });
    }

    const buildNetworkInfoData = (dataResponseNetworkInfoData) => {
      const networkValues = dataResponseNetworkInfoData.data.NetworkInterfaces.map((ni, index) => ({
        ...ni,
        text: `Red ${index + 1}`,
        value: ni.InterfaceName,
        Bandwidth: 0,
        PrimaryDNS: null,
        DnsType: null,
      }));

      networkConfigData.value = networkValues;
      originalNetworksData.value  = JSON.parse(JSON.stringify(networkValues));
    }

    const fetchNetworkData = async () => {
      loadingSearch.value = true;

      if (!bandWidthData.value.min && !bandWidthData.value.max) {
        await getBandWidthLimit();
      }

      const params = {
        idDvr: props.hanwhaDvr.id,
        id_dvr: props.hanwhaDvr.id
      }

      const getNetworkInfoData = axios.get('/v1/hanwha/dvr/admin/get_network_info', { params });
      const getBandWidth = axios.get('/v1/hanwha/dvr/admin/get_widthband', { params });
      const getDns = axios.get('/v1/hanwha/dvr/admin/get_dns', { params })

      await Promise.all([getNetworkInfoData,getBandWidth,getDns])
        .then(response => {
          const [responseNetworkInfoData,responseBandWidth,responseDns] = response;
          const { data: dataResponseNetworkInfoData } = responseNetworkInfoData;
          const { data: dataResponseBandWidth } = responseBandWidth;
          const { data: dataResponseDns } = responseDns;

          buildNetworkInfoData(dataResponseNetworkInfoData);
          buildBandWitdhData(dataResponseBandWidth);
          buildDnsData(dataResponseDns);
        })
        .catch((error) => {
          networkConfigData.value = [];
        });

      loadingSearch.value = false;
    }

    const gatewayDefaultChange = (InterfaceName) => {
      networkConfigData.value.forEach(ncd => {
        ncd.IsDefaultGateway = false;
      });

      const network = networkConfigData.value.find(ncd => (ncd.InterfaceName === InterfaceName));

      network.IsDefaultGateway = true;
      defaultGateway.value     = network;
    }

    const getBandWidthLimit = async () => {
      const params = {
        id_dvr: props.hanwhaDvr.id
      }

      showAlert.value = false;

      await axios.get('/v1/hanwha/dvr/admin/get_widthband_limit', { params })
        .then(async (response) => {
          const { data } = response;

          bandWidthData.value.min = data.data.bandwidth_limit.min;
          bandWidthData.value.max = data.data.bandwidth_limit.max;
        })
        .catch(() => {
          bandWidthData.value = {
            min: 0,
            max: 0
          }
        });
    }

    const saveNetworkData = async () => {
      showAlert.value = false;

      const networksUpdates = validateChanges();

      if (!networksUpdates.length) {
        showAlert.value = true;
        return
      }

      const request = {
        id_dvr: props.hanwhaDvr.id,
        networks: networksUpdates
      }

      loading.value = true;

      await axios.post('/v1/hanwha/dvr/admin/set-network-config', request)
        .then(async (response) => {
          const { data } = response;

          showAlert.value = false;

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          });

          await fetchNetworkData();
        })
        .catch((error) => {
          const { response } = error;

          toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        })
        .finally(() => {
          loading.value = false;
        });
    }

    const selectNetwork = (network) => {
      selectedNetwork.value = network;
    }

    const setNetworkGatewayDefault = (value) => {
      networkGatewayDefault.value = value;
    }

    const updateField = (item) => {
      item.updated = true;
    }

    const validateBandwidthLimit = (item) => {
      let value = Number(item.BitrateLimit);

      if (value > bandWidthData.value.max) {
          value = bandWidthData.value.max;
      }

      if (value < bandWidthData.value.min) {
          value = bandWidthData.value.min;
      }

      item.BitrateLimit = Number(value.toFixed(2));
      item.updated = true;
    }

    const validateChanges = () => {
      const networksChanges = networkConfigData.value.filter((network, index) => {
        const original = originalNetworksData.value[index];

        return JSON.stringify(network) !== JSON.stringify(original);
      });

      return networksChanges;
    }

    return {
      bandWidthData,
      fields,
      loading,
      loadingSearch,
      networkConfigData,
      networkGatewayDefault,
      selectedNetwork,
      showAlert,
      withPopper: popperHelper.withPopper,

      bandWidthLimit,
      buttonText,
      defaultGateway,

      fetchNetworkData,
      gatewayDefaultChange,
      saveNetworkData,
      selectNetwork,
      setNetworkGatewayDefault,
      updateField,
      validateBandwidthLimit
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .network-config-dialog {
  max-width: 35vw;
}

.content-network-data {
  min-height: 360px;
}

.border-channel {
  border: 1px solid rgba(0, 0, 0, .13);
}
</style>
